export default function FluidHeader() {
  // Hide Header on on scroll down
  const doc = document.documentElement
  const w = window

  let prevScroll = w.scrollY || doc.scrollTop
  let curScroll
  let direction = 0
  let prevDirection = 0

  const header = document.querySelector('.o-header')

  window.addEventListener(
    'scroll',
    function (e) {
      let top = this.scrollY

      if (top > 2) {
        header.classList.remove('background')
      } else {
        header.classList.add('background')
      }
    },
    false
  )

  const checkScroll = function () {
    curScroll = w.scrollY || doc.scrollTop
    if (curScroll > prevScroll) {
      //scrolled up
      direction = 2
    } else if (curScroll < prevScroll) {
      //scrolled down
      direction = 1
    }
    if (direction !== prevDirection) {
      toggleHeader(direction, curScroll)
    }
    prevScroll = curScroll
  }
  const toggleHeader = function (direction, curScroll) {
    if (direction === 2 && curScroll > 200) {
      //replace 52 with the height of your header in px
      header.classList.add('hide')
      prevDirection = direction
    } else if (direction === 1) {
      header.classList.remove('hide')
      prevDirection = direction
    }
  }
  window.addEventListener('scroll', checkScroll)
}
